<template>
  <transition-group name="modals-container" tag="div" ref="modalsContainer">
    <div class="modals-container" v-for="modal in modals" :key="modal.name" :class="className(modal)">
      <component class="modals-container__content" :is="modal.name" :modalData="modal.props" ref="modalsContent"></component>
      <div @click="closeModal" class="modals-container__overlay"></div>
    </div>
  </transition-group>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModalsContent from './modals-content'
  import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
  import { focusElement } from '@/helpers'

  export default {
    components: {
      ...ModalsContent
    },
    computed: {
      ...mapGetters('modals', [
        'modals'
      ])
    },
    watch: {
      'modals': {
        handler (val) {
          this.handleBodyScroll(val)

          this.$nextTick(() => {
            this.focusModal()
          })
        }
      },
      deep: true
    },
    methods: {
      closeModal () {
        const isCloseEventDisabled = this.modals.length && this.modals[this.modals.length - 1].props.disableCloseEventsOnContainer

        if (isCloseEventDisabled) return

        this.$store.commit('modals/CLOSE_LAST_MODAL')
      },
      handleKeyEvent (e) {
        if (e.keyCode === 27) {
          this.closeModal()
        }
      },
      className (modal) {
        return {
          'modals-container--solid-bg': modal.name === 'ModalIframe'
        }
      },
      handleBodyScroll (modals) {
          const { modalsContainer } = this.$refs
          modals.length ? disableBodyScroll(modalsContainer) : clearAllBodyScrollLocks(modalsContainer)
      },
      focusModal () {
        const { modalsContent } = this.$refs

        if (modalsContent && modalsContent.length) {
          const modalOnTheTop = modalsContent[modalsContent.length - 1]
          focusElement(modalOnTheTop.$el)

          return modalOnTheTop
        }
      }
    },
    mounted () {
      document.addEventListener('keydown', this.handleKeyEvent)
    },
    destroyed () {
      document.removeEventListener('keydown', this.handleKeyEvent)
    }
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/breakpoints.scss';
  
  .modals-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999999;
    display: flex;
    align-items: center;
    justify-content: center;

    @include media(ltTablet) {
      // padding-top: 55px;
    }

    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 24px;
      cursor: pointer;
    }

    &__overlay {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      background-color: #000;
      opacity: 0.4;
    }

    &__content {
      display: flex;
      flex-direction: column;
      max-height: 100%;
      background-color: #fff;
      border: 1px solid $color-dusty-gray;
      border-radius: 6px;
      box-shadow: 0 31px 41px 0 rgba(32,42,53,.2), 0 2px 16px 0 rgba(32,42,54,.08);

      > * {
        flex-shrink: 0;
      }
    }

    &__scroll-content {
      overflow: auto;
      flex-shrink: 1 !important;
    }

    &--solid-bg {
      .modals-container__overlay {
        background-color: $color-athens-gray;
        opacity: 1;
      }

      .modals-container__content {
        border: none;
        box-shadow: 0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.15);
      }
    }
  }

  .modals-container-enter-active, .modals-container-leave-active {
    transition: opacity .2s;

    .modals-container__content {
      transition: transform .2s;
    }
  }
  .modals-container-enter, .modals-container-leave-to {
    opacity: 0;

    .modals-container__content {
      transform: translateY(100%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalContainer.vue